// VUE
// Vue specific stuff
// Split VUE into Mirror/Anywhere/Presenter and Common?
import TurbolinksAdapter from "vue-turbolinks";
// COMPONENTS
import Vue from "vue/dist/vue.esm";
import App from "components/app.vue";
import RoomCard from "components/room-card.vue";
import Viewport from "components/viewport.vue";
import ViewportControls from "components/viewport-controls.vue";
import Chat from "components/chat.vue";
import ParticipantList from "components/participant-list.vue";
import Participant from "components/participant.vue";
import SoundMeter from "components/sound-meter.vue";
import VerticalStepper from "components/vertical-stepper.vue";
import Modal from "components/modal.vue";
import VideoPlayer from "components/video-player.vue";
import RateSession from "components/rate-session.vue";
import TimeZoneFinder from "components/time-zone-finder.vue";
import ManageParticipants from "components/manage-participants.vue";
import RefereesTable from "components/referees-table.vue";
import PeriodsButton from "components/periods-button.vue";
import SoundReactions from "components/sound-reactions.vue";
import ConnectionQuality from "components/connection-quality.vue";

// DETECT BROWSER INJECTION
import { detectBrowser } from "utils/browser";

// import * as Sentry from "@sentry/browser";
// import { CaptureConsole } from "@sentry/integrations";

// Sentry.init({
//   dsn: "https://f98ecd0f45d8ed5a86778cf5ba04f5a3@o4505988040491008.ingest.sentry.io/4505992525381632",
//   environment: process.env.NODE_ENV,
//   integrations: [
//     new Sentry.BrowserTracing({
//       // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//       tracePropagationTargets: ["localhost", /https:\/\/(beta\.)?(anywhere|mirror|vo|presenter)?\.mictap\.com/],
//     }),
//     new Sentry.Replay(),
//     new CaptureConsole({
//       levels: ['warn', 'error']
//     }), // 'log', 'debug', 'info'
//   ],
//   // Performance Monitoring
//   tracesSampleRate: 0.2, // Capture 100% of the transactions, reduce in production!
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

// Mirror specific
import registerMirrorComponents from "./vue/mirror-vue";
registerMirrorComponents(Vue);

// Anywhere specific
import registerAnywhereComponents from "./vue/anywhere-vue";
registerAnywhereComponents(Vue);

// Presenter specific
import registerPresenterComponents from "./vue/presenter-vue";
registerPresenterComponents(Vue);

Vue.use(TurbolinksAdapter);

Vue.component("app", App);

// Common
Vue.component("room-card", RoomCard);
Vue.component("viewport", Viewport);
Vue.component("viewport-controls", ViewportControls);
Vue.component("chat", Chat);

Vue.component("participant-list", ParticipantList);
Vue.component("participant", Participant);
Vue.component("sound-meter", SoundMeter);
Vue.component("vertical-stepper", VerticalStepper);
Vue.component("modal", Modal);
Vue.component("video-player", VideoPlayer);
Vue.component("rate-session", RateSession);
Vue.component("time-zone-finder", TimeZoneFinder);
Vue.component("manage-participants", ManageParticipants);
Vue.component("referees-table", RefereesTable);
Vue.component("periods-button", PeriodsButton);
Vue.component("sound-reactions", SoundReactions);
Vue.component("connection-quality", ConnectionQuality);

Vue.mixin({
  methods: {
    currentBrowser: () => detectBrowser(window).browser,
    capitalize: (s) =>
      typeof s === "string" && s !== ""
        ? s.charAt(0).toUpperCase() + s.slice(1)
        : "",
  },
});

document.addEventListener("turbolinks:load", () => {
  const app = new Vue({
    el: '[data-behavior="vue"]',
  });
  window.vm = app;
});
